$bog_builderui_studio_pick $mol_select
	label \
	dot_color \transparent
	style *
		--bog_builderui_studio_pick_dot <= dot_color
	trigger_content /
		<= Texts $mol_view sub /
			<= Label $mol_view sub /
				<= label
			<= Value $mol_view sub /
				<= title
		<= Dot $mol_view
